export default __webpack_public_path__ + "217213b.png";